const openModal = ( el ) => {
	document.querySelector('.g-Body').classList.add('js-modal-active');
	document.querySelector(el).classList.add('js-active');
	document.querySelector(el).setAttribute('tabindex', '0');
	document.querySelector(el).focus();
}

const closeModal = ( el ) => {
	document.querySelector('.g-Body').classList.remove('js-modal-active');
	document.querySelector('.g-Modal.js-active').classList.remove('js-active');
}

const proceedLink = ( link ) => {
	return window.open(link, '_blank');
}

const trainingKitTrigger = document.querySelectorAll('.g-TrainingKitTrigger');
const leavingSiteTrigger = document.querySelectorAll('.g-LeavingSite');
const hcpTrigger = document.querySelector('.m-Menu .m-MenuItem:last-child');
const cancelButton = document.querySelectorAll('.g-Modal_CTACancel');
const bodyOverlay = document.querySelector('.g-BodyOverlay');
const continueButton = document.querySelector('.g-Modal_CTAContinue');
const howToVideo = document.querySelector('.g-HowToVideoTrigger');
const trainingKitVideo = document.querySelector('.g-TrainingKitVideoTrigger');

if ( trainingKitVideo ) {
	trainingKitVideo.addEventListener( 'click', (e) => {
		e.preventDefault();
		openModal('.g-training-kit-video');
	});
}

if ( howToVideo ) {
	howToVideo.addEventListener( 'click', (e) => {
		e.preventDefault();
		openModal('.g-HowToVideo');
	});
}
// videoTriggers.forEach( (videoTrigger) => {
// 	videoTrigger.addEventListener('click', (e) => {
// 		e.preventDefault();
// 		openModal('.g-HowToVideo');
// 	});
// });

hcpTrigger.addEventListener( 'click', (e) => {
	e.preventDefault();
	openModal('.g-Modal_HCP');
});

continueButton.addEventListener('click', (e) => {
	closeModal();
})

Array.from(trainingKitTrigger).forEach( (el) => {
	el.addEventListener( 'click', (e) => {
		e.preventDefault();
		openModal('.g-Modal_TrainingKit');
	})
})

Array.from(leavingSiteTrigger).forEach( ( trigger ) => {
	trigger.addEventListener('click', (e) => {
		e.preventDefault();
		openModal('.g-Modal_LeavingSite');
		document.querySelector('.g-Modal_CTAOK').href = trigger.href;
	})
	document.querySelector('.g-Modal_CTAOK').addEventListener('click', (e) => {
		e.preventDefault()
		proceedLink(trigger.href);
		closeModal();
	})
});

Array.from(cancelButton).forEach( (el) => {
	el.addEventListener('click', (e) => {
		e.preventDefault();
		closeModal();
	})
})

// const toggleIframeSrc = () => {
// 	document.querySelectorAll('.g-Modal iframe').forEach((iframe) => {
// 		var src = iframe.getAttribute('src');
// 		var stop = '';
// 		if (!document.querySelector('body').matches('.js-modal-active')) {
// 			iframe.setAttribute('src', stop);
// 			console.log(src + stop);
// 		}
// 	});
// }
const toggleIframeSrc = () => {
	var iframe = document.querySelector('div#howToVideo iframe');
	var player = new Vimeo.Player(iframe);
	player.pause();

	var iframe2 = document.querySelector('div#TrainingKit iframe');
	var player2 = new Vimeo.Player(iframe2);
	player2.pause();
}

bodyOverlay.addEventListener('click', () => {
	closeModal();
	toggleIframeSrc();
});
